"use client";

import { motion } from "framer-motion";
import { useTranslations } from "next-intl";

import { EmptyState } from "@/components/shared/EmptyState";
import { SteamingPot } from "@/components/shared/SteamingPot";
import { Link } from "@/i18n/navigation";
import { fadeSlideUpVariants } from "@/lib/animations";

export function EmptyDashboard() {
  const t = useTranslations("dashboard");

  return (
    <motion.div
      className="flex flex-1 flex-col items-center justify-center px-6"
      variants={fadeSlideUpVariants}
      initial="hidden"
      animate="visible"
    >
      <EmptyState
        icon={
          <div className="size-20 @md:size-28 flex items-center justify-center">
            <SteamingPot className="size-full text-text-secondary" />
          </div>
        }
        title={t("emptyTitle")}
        description={t.rich("emptyDescription", {
          link: (chunks) => (
            <Link
              href="/calendar"
              className="text-primary underline underline-offset-2 pointer-events-auto"
            >
              {chunks}
            </Link>
          ),
        })}
      />
    </motion.div>
  );
}
